import * as ActionType from '../actions/types'
import { getAssetPath, getEntryPoint } from 'settings/app/helpers'

const INITIAL_STATE = {
  entryPoint: getEntryPoint(),
  staticAssetPath: getAssetPath(),
  error: false,
  wantGoogleMaps: false,
  naviType: false,
  release: {
    revision: false,
    time: false,
  },
}

/**
 * application reducer
 * @param state
 * @param action
 * @returns {{entryPoint: null, error: boolean}|{entryPoint: *, error: boolean}}
 */
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_MODULE_ENTRY_POINT:
      return {
        ...state,
        entryPoint: action.payload.moduleEntryPoint,
        staticAssetPath: action.payload.staticAssetPath,
        naviType: action.payload.naviType,
      }

    case ActionType.RESET_MODULE_ENTRY_ENTRY:
    case ActionType.RESET_PREVIOUSLY_CACHE:
      return {
        ...INITIAL_STATE,
      }

    case ActionType.SET_MOBILE_DEVICE:
      return {
        ...state,
        mobileDevice: action.payload,
      }

    case ActionType.SET_WANT_GOOGLE_MAPS:
      return {
        ...state,
        wantGoogleMaps: action.payload,
      }

    case ActionType.SET_BUILD_SPECS:
      return {
        ...state,
        release: {
          revision: action.payload.revision,
          buildTime: action.payload.buildTime,
        },
      }

    default:
      return state
  }
}
